<template>
    <div id="app">
        <div v-if="!audioEnabled" class="audio-permission">
            <div class="audio-permission-card">
                <h2>Ativar voz do painel</h2>
                <p>{{ audioStatus }}</p>
                <button type="button" @click="activateAudio">ATIVAR VOZ</button>
            </div>
        </div>

        <section v-show="!calledUser" class="welcome">
            <div class="container">
                <div v-show="!calledUser && lastCall.length > 0" class="row" style="width: fit-content; float: left;">
                    <div v-for="item in lastCall" class="box-card">
                        <div class="box-img">
                            <!-- <img class="photo" :src="item.photo != '' ? item.photo : '/assets/img/avatar.png'" alt="" /> -->
                            <img v-if="item.photo == '' || item.photo == null || testPhoto(item.photo)" class="photo" :src="'/assets/img/avatar.png'" alt="teste2" />
                            <img v-else class="photo" :src="item.photo" alt="photo" />
                        </div>
                        <div class="box-info">
                            <span class="typelabel" v-show="item.label">acompanhante</span>
                            <h3 class="firstname">{{item.shortname}}</h3>
                            <h4 class="destination">{{item.destination}}</h4>
                            <h5 class="floor">{{ item.floor }}</h5>
                            <p class="time">{{ updateTimeAgo(item.time) }}</p>
                        </div>
                    </div>
                </div>
                <div :class="alignInfo()">
                    <div class="col">
                        <div class="infos">
                            <img class="logo" :src="'/assets/img/' + hospital.logo" alt="" 
                                style="border-radius: 500px; box-shadow: 0 1px 6px 0 #000; border-color: rgba(223,225,229,0);"
                            />
                            <h1 class="name">Seja bem-vindo</h1>
                            <h2 class="current-time">{{ currentTime }}</h2>
                            <h3 class="current-date">{{ currentDate }}</h3>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section v-show="calledUser" class="calling-user">
            <div class="container">
                <div class="row">
                    <div class="col">
                        <div class="infos">
                            <img v-show="!user.label" class="photo" :src="user.photo" alt="" style="border-radius: 500px;" />
                            <h4 v-show="user.label" class="treatment">{{ user.treatment }}</h4>
                            <h3 class="name">{{ user.fullname }}</h3>

                            <h4 class="destination">
                                {{ user.destination }} <span v-if="user.floor !== ''">- {{ user.floor }}</span>
                            </h4>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section v-show="!calledUser && lastCalledList.length > 0" class="last-calls">
            <div class="container">
                <div class="row" style="padding: 0 20px;">
                    <div v-for="item in lastCalls" class="card">
                        <div class="photo">
                            <!-- <img :src="item.photo != '' ? item.photo : '/assets/img/avatar.png'" alt=""> -->
                            <img v-if="item.photo == '' || item.photo == null || testPhoto(item.photo)" :src="'/assets/img/avatar.png'" alt="teste2" />
                            <img v-else :src="item.photo" alt="photo2" />
                        </div>
                        <div class="info">
                            <h3>{{ item.shortname }}</h3>
                            <h4>{{ item.destination }}</h4>
                            <p>{{ updateTimeAgo(item.time) }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <a class="btn-primar" style="display:none;"
        ref="botaoChamar" 
        @click="chamar()"
        >CHAMAR</a>
        <footer>
            <img :src="'/assets/img/inkless-horizontal-branca.png'" alt="" />
            <!-- <p>{{ copyright }}</p> -->
        </footer>
    </div>
</template>
<script>
import io from 'socket.io-client';
export default {
    name: 'PainelChamada',
    data() {
        return {
            hospital: {
                logo: 'client-logo.png',
                name: ''
            },
            currentTime: '',
            currentDate: '',
            user: {},
            calledUser: false,
            lastCalledList: [],
            // dev
            socket : '', //io('localhost:3030'),
            // production
            //socket: io('http://painel-gastrovita.inkless.digital:3030'),
            voiceSpeech: new window.SpeechSynthesisUtterance(),
            voiceSynth: window.speechSynthesis,
            voiceList: [],
            voiceSelected: 14,
            voicePitch: 14, // De [0 - 20], defaults to 10
            voiceRate: 10, // De [0 - 10], defaults to 10
            voiceVolume: 10, // De [0 - 10], defaults to 10
            audioEnabled: false,
            audioStatus: 'O navegador precisa de um clique para permitir os anúncios.',
            pendingCall: null,
        }
    },
    mounted() {
        const socketUrl = window.painelServerUrl || window.location.origin;

        this.log('info', 'Componente montado', {
            socketUrl,
            speechSynthesisAvailable: 'speechSynthesis' in window,
            speechUtteranceAvailable: 'SpeechSynthesisUtterance' in window
        });
        this.log('info', 'Conectando ao Socket.IO', { socketUrl });
        this.socket = io(socketUrl, {
            reconnection: true
        });
        var app = this;
        this.setClient();
        this.getDateHour();
        this.socket.on('connect', () => {
            this.log('info', 'Socket.IO conectado', {
                socketId: this.socket.id,
                transport: this.socket.io.engine && this.socket.io.engine.transport.name
            });
        });
        this.socket.on('connect_error', error => {
            this.log('error', 'Falha ao conectar ao Socket.IO', {
                message: error.message,
                socketUrl
            });
        });
        this.socket.on('connect_timeout', timeout => {
            this.log('error', 'Tempo de conexão com Socket.IO esgotado', { timeout, socketUrl });
        });
        this.socket.on('disconnect', reason => {
            this.log('warn', 'Socket.IO desconectado', { reason });
        });
        this.socket.io.on('reconnect', attempt => {
            this.log('info', 'Socket.IO reconectado', { attempt, socketId: this.socket.id });
        });
        this.socket.io.on('reconnect_attempt', attempt => {
            this.log('warn', 'Tentando reconectar ao Socket.IO', { attempt, socketUrl });
        });
        this.socket.io.on('reconnect_error', error => {
            this.log('error', 'Erro ao reconectar ao Socket.IO', { message: error.message });
        });
        this.socket.io.on('reconnect_failed', () => {
            this.log('error', 'Socket.IO esgotou as tentativas de reconexão', { socketUrl });
        });
        this.socket.on('emitMessage', calledUser => {
            this.log('info', 'Evento emitMessage recebido', this.callMetadata(calledUser));
            app.getCalledUser(calledUser);
        });
        this.loadVoices();
        this.voiceSynth.addEventListener('voiceschanged', this.loadVoices);
    },
    computed: {
        lastCall: function() {
            return this.lastCalledList.slice(0, 1);
        },
		lastCalls: function() {
            return this.lastCalledList.slice(1, 7);
		}
	},
    methods: {
        log(level, message, details) {
            if (window.painelDebug) {
                window.painelDebug(level, message, details);
                return;
            }
            (console[level] || console.log)(`[Painel] ${message}`, details || '');
        },
        callMetadata(calledUser) {
            if (!calledUser || typeof calledUser !== 'object') {
                return { payloadType: typeof calledUser };
            }

            return {
                fields: Object.keys(calledUser),
                hasName: typeof calledUser.name === 'string' && calledUser.name.length > 0,
                hasDestination: typeof calledUser.destination === 'string' && calledUser.destination.length > 0,
                hasTreatment: typeof calledUser.treatment === 'string' && calledUser.treatment.length > 0,
                hasPhoto: typeof calledUser.photo === 'string' && calledUser.photo.length > 0
            };
        },
        loadVoices() {
            this.voiceList = this.voiceSynth.getVoices();
            this.log('info', 'Vozes disponíveis carregadas', {
                count: this.voiceList.length,
                languages: Array.from(new Set(this.voiceList.map(voice => voice.lang)))
            });
        },
        selectPortugueseVoice(utterance) {
            const portugueseVoice = this.voiceList.find(voice =>
                voice.lang && voice.lang.toLowerCase() === 'pt-br'
            );

            utterance.lang = 'pt-BR';
            if (portugueseVoice) {
                utterance.voice = portugueseVoice;
            }

            this.log('info', 'Voz selecionada para o anúncio', {
                voiceFound: Boolean(portugueseVoice),
                voiceName: portugueseVoice && portugueseVoice.name,
                language: portugueseVoice ? portugueseVoice.lang : utterance.lang
            });
        },
        activateAudio() {
            if (!('speechSynthesis' in window) || !('SpeechSynthesisUtterance' in window)) {
                this.audioStatus = 'Este navegador não oferece suporte à síntese de voz.';
                this.log('error', 'Síntese de voz não suportada pelo navegador');
                return;
            }

            this.loadVoices();
            this.voiceSynth.cancel();

            const activationSpeech = new SpeechSynthesisUtterance('Voz ativada');
            this.selectPortugueseVoice(activationSpeech);
            this.audioStatus = 'Ativando a voz...';

            activationSpeech.onstart = () => {
                this.audioEnabled = true;
                this.log('info', 'Voz autorizada por interação do usuário');
            };
            activationSpeech.onend = () => {
                this.audioEnabled = true;
                const pendingCall = this.pendingCall;
                this.pendingCall = null;

                if (pendingCall) {
                    this.log('info', 'Executando chamada que aguardava ativação da voz');
                    this.params = pendingCall;
                    this.$nextTick(() => this.chamar());
                }
            };
            activationSpeech.onerror = event => {
                this.audioEnabled = false;
                this.audioStatus = `Não foi possível ativar a voz (${event.error}). Clique novamente.`;
                this.log('error', 'Falha ao autorizar a síntese de voz', { error: event.error });
            };

            this.voiceSynth.speak(activationSpeech);
        },
        testPhoto(photo) {
            var photoSplit = photo.split('/');
            if (photoSplit[photoSplit.length - 1] == 'null') {
                return 'null'
            }
        },
        alignInfo() {
            if (this.lastCalledList.length == 0) {
                return 'row justify-content-md-center'
            } else {
                return 'row company-info'
            }
        },
        chamar() {
            var calledUser = this.params;

            if (!calledUser) {
                this.log('error', 'Tentativa de anunciar sem chamada processada');
                return;
            }

            if (!this.audioEnabled) {
                this.pendingCall = calledUser;
                this.audioStatus = 'Existe uma chamada aguardando. Clique para ativar a voz.';
                this.log('warn', 'Chamada aguardando autorização de voz do navegador');
                return;
            }
            
            let article = 'ao';

			if (calledUser.destination.toLowerCase().includes('sala') || calledUser.destination.toLowerCase().includes('gestão')) {
				article = 'à';
			}

			let voiceMessage = `${calledUser.treatment} ${calledUser.fullname.toLowerCase()}, por favor, dirija-se ${article} ${calledUser.destination} ${calledUser.floor}.`;
            voiceMessage = voiceMessage.replace(/  +/g, ' ');
            this.voiceSpeech.text = voiceMessage;
            this.selectPortugueseVoice(this.voiceSpeech);
            this.log('info', 'Enviando anúncio para síntese de voz', {
                characterCount: voiceMessage.length,
                hasDestination: Boolean(calledUser.destination),
                hasFloor: Boolean(calledUser.floor)
            });
            
            this.voiceSpeech.onstart = () => {

                this.log('info', 'Síntese de voz iniciada');
                this.user = calledUser;
                this.listLastCalls(calledUser);
                this.calledUser = true;
            };
            
            this.voiceSpeech.onend = () => {

                this.log('info', 'Síntese de voz finalizada');
                this.user = {};
                this.calledUser = false;
            };
            this.voiceSpeech.onerror = event => {
                this.log('error', 'Falha na síntese de voz', {
                    error: event.error,
                    elapsedTime: event.elapsedTime,
                    charIndex: event.charIndex
                });
                this.user = {};
                this.calledUser = false;
                if (event.error === 'not-allowed') {
                    this.audioEnabled = false;
                    this.pendingCall = calledUser;
                    this.audioStatus = 'O Chrome bloqueou a voz. Clique para autorizar e repetir a chamada.';
                }
            };
            this.voiceSynth.speak(this.voiceSpeech);
        },
        setClient() {
            this.hospital.name = 'HOSPITAL GASTROVITA'
        },
        getDateHour() {
            setInterval(() => {
                this.currentTime = moment().format('LTS');
            }, 1000);
            
            this.currentDate = moment().format('dddd, DD/MMMM');
        },
        updateTimeAgo(time) {
			if (this.lastCalledList.length > 0) {
				return moment(time, 'YYYYMMDD, hh:mm:ss a').fromNow();
			}
        },
        getCalledUser(calledUser) {

			if (!calledUser || typeof calledUser.name !== 'string' || typeof calledUser.destination !== 'string') {
				this.log('error', 'Chamada recebida com dados inválidos', this.callMetadata(calledUser));
				return;
			}

			this.log('debug', 'Processando chamada recebida', this.callMetadata(calledUser));
			const name = calledUser.name.split(' ');
			const firstName = name[0];
			const lastName = name[name.length - 1];
			const shortName = `${firstName} ${lastName}`;

			const dest = calledUser.destination.split('-');
			const destination = dest[0];
			const floor = dest[dest.length - 1];

			let treatmentLabel = false;
			let treatment = calledUser.treatment || '';

			const treatmentArray = treatment.split(' ');

			if (treatmentArray[0].toLowerCase() == 'acompanhante') {
				treatment = 'Acompanhante de';
				treatmentLabel = true;
			} else {
				treatment = '';
			}

			if (dest[0].toLowerCase().includes('sala')) {
				treatmentLabel = true;
				treatment = 'Acompanhante de';
			} else {
				treatment = '';
			}

            this.params = {
				label: treatmentLabel,
				treatment: treatment,
				fullname: calledUser.name,
				shortname: shortName,
				destination: destination,
				floor: floor === destination ? '' : floor,
				photo: calledUser.photo
            };
            this.log('info', 'Chamada processada; iniciando anúncio', {
                hasDestination: Boolean(this.params.destination),
                hasFloor: Boolean(this.params.floor),
                hasPhoto: Boolean(this.params.photo),
                isCompanion: this.params.label
            });
            this.$refs.botaoChamar.click();
			//this.voiceCalledUser(params);
        },
        voiceCalledUser(calledUser) {
			let article = 'ao';

			if (calledUser.destination.toLowerCase().includes('sala') || calledUser.destination.toLowerCase().includes('gestão')) {
				article = 'à';
			}

			let voiceMessage = `${calledUser.treatment} ${calledUser.fullname}, por favor, dirija-se ${article} ${calledUser.destination} ${calledUser.floor}.`;

			voiceMessage = voiceMessage.replace(/  +/g, ' ');

			if ('speechSynthesis' in window) {
                var app = this;
                var utterThis = new SpeechSynthesisUtterance(voiceMessage);
                var voices = speechSynthesis.getVoices();
                //var voice_br = voices[14];
                var voice_br = {};
                voices.map((value, i) => {
                    if (value.lang == 'pt-BR') {
                    voice_br = value;
                    }
                });
                window.speechSynthesis.speak(utterThis);

                utterThis.onstart = () => {
					this.user = calledUser;
					this.listLastCalls(calledUser);
					this.calledUser = true;
                };
                
                utterThis.onend = () => {
					this.user = {};
					this.calledUser = false;
				};
			}
        },
        listLastCalls(calledUser) {
			let addItem = true;

			if (this.lastCalledList.length > 0) {
				const listLastFour = this.lastCalledList.slice(0, 4);

				for (let element of listLastFour) {
					const nameBoolean = Object.is(element.fullname, calledUser.fullname);
					const destinationBoolean = Object.is(element.destination, calledUser.destination);

					if (nameBoolean && destinationBoolean) {
						addItem = false;
						break;
					}
				}
			}

			if (addItem) {
				calledUser.time = moment().format('YYYYMMDD, h:mm:ss a');
				this.lastCalledList = [calledUser].concat(this.lastCalledList);
			}
		},
    }
}
</script>
<style scoped>
#app {
    box-sizing: border-box;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: flex-start;
    min-height: 100vh;
    overflow: hidden;
    padding-bottom: 38px;
}
.audio-permission {
    align-items: center;
    background: rgba(0, 0, 0, 0.72);
    display: flex;
    inset: 0;
    justify-content: center;
    position: fixed;
    z-index: 10000;
}
.audio-permission-card {
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.35);
    color: #333;
    max-width: 560px;
    padding: 36px;
    text-align: center;
    width: calc(100% - 48px);
}
.audio-permission-card h2 {
    margin-bottom: 12px;
}
.audio-permission-card button {
    background: #278fda;
    border: 0;
    border-radius: 6px;
    color: #fff;
    cursor: pointer;
    font-size: 24px;
    margin-top: 16px;
    padding: 14px 28px;
}
.company-info {
    flex: 0 1 42%;
    float: none;
    justify-content: center;
    margin: 0;
    width: auto;
}
.infos {
    font-family: "Source Sans Pro light";
}
.infos h3 {
    letter-spacing: 0px;
}
.welcome {
    align-items: center;
    display: flex;
    flex: 1 1 auto;
    min-height: 0;
}
.welcome > .container {
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: space-around;
    padding: 18px 3vw;
}
.welcome > .container > .row {
    float: none !important;
    margin: 0;
}
.welcome .logo {
    max-width: min(180px, 20vh);
    margin-bottom: 14px;
}
.welcome .name {
    font-size: clamp(24px, 2vw, 38px);
    margin-bottom: 10px;
}
.welcome .current-time {
    font-size: clamp(90px, 9vw, 170px);
}
.welcome .current-date {
    font-size: clamp(28px, 3vw, 54px);
    white-space: nowrap;
}
.box-card {
    align-items: center;
    display: grid;
    grid-template-columns: minmax(210px, 300px) minmax(360px, 1fr);
    margin-left: 0;
    max-width: 820px;
    width: 47vw;
}
.box-img {
    float: none;
    margin: 0;
    width: min(300px, 18vw);
    z-index: 1;
}
.box-img img {
    aspect-ratio: 1;
    width: 100%;
    height: auto;
    object-fit: cover;
    border-radius: 500px;
    box-shadow: 0 1px 6px 0 #000;
    border-color: rgba(223,225,229,0);
}
.box-info {
    align-self: center;
    background: rgb(255, 255, 255);
    border-radius: 10px;
    margin-left: -80px;
    min-height: 260px;
    padding-left: 80px;
    width: 100%;
}
.box-info .typelabel {
    font-size: clamp(20px, 1.8vw, 32px) !important;
}
.box-info h3 {
    font-size: clamp(34px, 3.5vw, 62px);
    padding-top: 42px;
}
.box-info h4 {
    font-size: clamp(28px, 2.8vw, 48px);
    padding-top: 10px;
}
.box-info h5 {
    font-size: clamp(22px, 2vw, 36px);
}
.box-info p {
    font-size: clamp(18px, 1.5vw, 28px);
    margin-top: 18px;
    padding-right: 34px;
}
.last-calls {
    flex: 0 0 230px;
    overflow: hidden;
    padding: 8px 0 14px;
}
.last-calls .row {
    flex-wrap: nowrap;
    gap: 24px;
    justify-content: center;
    margin: 0;
    overflow: hidden;
    padding: 0 30px !important;
}
.card {
    flex: 0 1 240px;
    margin-left: 0;
    max-width: 240px;
    min-width: 0;
    width: calc((100vw - 180px) / 6);
    background: none;
    border:none;
}
.card .photo {
    height: 48px;
    width: min(120px, 70%);
    margin: 0 auto;
}
.card .photo {
    z-index: 999;
}
.photo img {
    aspect-ratio: 1;
    height: auto;
    margin: 0 auto;
    object-fit: cover;
    border-radius: 500px;
    box-shadow: 0 1px 6px 0 black;
    border-color: rgba(223,225,229,0);
    width: 100%;
}
.info {
    background: #fff;
    margin-top: 4px;
    min-height: 170px;
    padding: 78px 6px 6px;
    border-radius: 10px;
    text-align: center;
    border: 1px solid #eee;
    box-shadow: 0 1px 6px 0 gray;
}
.info h3 {
    font-weight: bold;
    font-size: clamp(16px, 1.35vw, 24px);
    text-transform: uppercase;
    border-bottom: 1px solid lightgray;
}
.info h4 {
    font-size: clamp(14px, 1.1vw, 20px);
    text-transform: uppercase;
}
.info p {
    font-size: clamp(12px, 0.9vw, 16px);
    margin-bottom: 0;
}
.calling-user {
    align-items: center;
    display: flex;
    flex: 1 1 auto;
    min-height: 0;
}

@media (max-height: 800px) {
    .welcome .logo {
        max-width: 130px;
    }
    .welcome .current-time {
        font-size: 100px;
    }
    .box-card {
        grid-template-columns: minmax(180px, 240px) minmax(320px, 1fr);
    }
    .box-img {
        width: min(240px, 16vw);
    }
    .box-info {
        min-height: 220px;
    }
    .box-info h3 {
        padding-top: 28px;
    }
    .last-calls {
        flex-basis: 190px;
    }
    .card .photo {
        width: 95px;
    }
    .info {
        min-height: 145px;
        padding-top: 62px;
    }
}
</style>
